export class Brand {
    public id: string;
    public file: string;
    public alt: string;
}

export const Brands: Brand[] = [
    {
        id: 'f00c37cc-accf-48c7-8c21-50b63f32d1c1',
        file: 'f00c37cc-accf-48c7-8c21-50b63f32d1c1.svg',
        alt: 'Mapfre Seguros'
    },
    {
        id: '29a138a1-a9e7-45f6-9b55-9f62f6e0972f',
        file: '29a138a1-a9e7-45f6-9b55-9f62f6e0972f.svg',
        alt: 'TOKIO MARINE SEGURADORA S.A.'
    },
    {
        id: '',
        file: 'XMLID_11_.svg',
        alt: 'Chubb Seguros'
    },
    {
        id: '3fd7a958-99ac-4783-9e30-101f74898c8e',
        file: '3fd7a958-99ac-4783-9e30-101f74898c8e.png',
        alt: 'Suhai Seguradora'
    },
    {
        id: 'a9488147-d925-4dbe-9074-d3fd57e71f68',
        file: 'a9488147-d925-4dbe-9074-d3fd57e71f68.svg',
        alt: 'Banco SICOOB'
    },
    {
        id: '79c206c7-021c-489f-8fd1-6f985faa1343',
        file: '79c206c7-021c-489f-8fd1-6f985faa1343.svg',
        alt: 'BB Seguros'
    },
    {
        id: '229a8f96-2d04-41c7-b498-ae8698690066',
        file: '229a8f96-2d04-41c7-b498-ae8698690066.png',
        alt: 'Seguros Sura'
    },
    {
        id: '6F52DECE-CFC4-4BFC-A6CD-7E697584001A',
        file: '6F52DECE-CFC4-4BFC-A6CD-7E697584001A.svg',
        alt: 'Allianz Seguradora'
    },
    {
        id: 'C1DB8823-6960-4555-A354-EEE9C31404A5',
        file: 'C1DB8823-6960-4555-A354-EEE9C31404A5.svg',
        alt: 'Youse'
    },
    {
        id: '215328DF-5FCC-4CC7-AA47-0FC41C13E50B',
        file: '215328DF-5FCC-4CC7-AA47-0FC41C13E50B.svg',
        alt: 'Yelum Seguradora'
    },
    {
        id: '0203d8b3-2121-47ac-8625-d13e0b1a52a1',
        file: '0203d8b3-2121-47ac-8625-d13e0b1a52a1.svg',
        alt: 'Banco Pan'
    }
];